<template>
    <StockPriceLine
        v-if="hasCompanyStockPrices"
        :companyStockPrices="item.companyStockPrices"
        :stockLineDate="eventMoment"
        :selectedCompanyIndex="selectedCompanyIndex"
        class="sparkline-line"
    />
</template>
<script>
import moment from 'moment'

import StockPriceLine from '../charts/stock-price-line.vue'

export default {
    components: {
        StockPriceLine,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        selectedCompany: {
            type: Number,
            require: false,
            default: null,
        },
    },
    computed: {
        hasCompanyStockPrices() {
            return this.item?.companyStockPrices.length > 0
        },
        eventMoment() {
            return moment(this.item?.effectiveDate)
        },
        selectedCompanyIndex() {
            if (this.selectedCompany) {
                const index = this.item.companyStockPrices.findIndex(csp => csp?.company?.id == this.selectedCompany)
                if (index != -1) {
                    return index
                }
            }
            return 0
        },
    },
}
</script>
